module.exports = __webpack_public_path__ + "assets/da38f0533cf70b4be093bac2ab857133.png";